// src/components/OnlineParticipants.js
import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import axios from 'axios';
import './OnlineParticipants.css'; // Import the CSS file for styling
import RoulettePro from 'react-roulette-pro';
import 'react-roulette-pro/dist/index.css';

const OnlineParticipants = () => {
	const [participants, setParticipants] = useState([]);
	const [loading, setLoading] = useState(true);
	const [error, setError] = useState(null);
	const [start, setStart] = useState(false);
	const { mid } = useParams();

	useEffect(() => {
		const fetchParticipants = async () => {
			if (!start) {
				try {
					const response = await axios.get(
						`${process.env.REACT_APP_SERVER_URL}/api/online-participants`
					);
					if (mid) {
						setParticipants(
							response.data.filter((p) => p.meeting_id === mid)
						);
					} else {
						setParticipants(response.data);
					}

					setLoading(false);
				} catch (err) {
					setError(err);
					setLoading(false);
				}
			}
		};

		fetchParticipants();

		if (!mid) {
			const intervalId = setInterval(fetchParticipants, 30000); // Update every 30 seconds
			return () => clearInterval(intervalId); // Cleanup on unmount
		}
		return;
	}, []);

	if (loading) return <div className="loading">Loading...</div>;
	if (error)
		return (
			<div className="error">Error fetching data: {error.message}</div>
		);

	// Group participants by meeting_id
	const groupedParticipants = participants.reduce((acc, participant) => {
		const { meeting_id } = participant;
		if (!acc[meeting_id]) {
			acc[meeting_id] = [];
		}
		acc[meeting_id].push(participant);
		return acc;
	}, {});

	const indexedParticipants = (participants) => {
		return participants.map((participant, index) => {
			return {
				image: '/images/avatar.jpg',
				text: participant.user_name,
				id:
					typeof crypto.randomUUID === 'function'
						? crypto.randomUUID()
						: generateId()
			};
		});
	};

	const randomIndex = (participants) => {
		return Math.floor(Math.random() * participants.length);
	};

	const handleStart = () => {
		setStart((prevState) => !prevState);
	};

	const generateId = () =>
		`${Date.now().toString(36)}-${Math.random().toString(36).substring(2)}`;

	return (
		<div className="container">
			<h1>Live Webinars and Meetings</h1>
			{Object.keys(groupedParticipants).length === 0 ? (
				<p>No participants currently online.</p>
			) : (
				Object.keys(groupedParticipants).map((meetingId) => (
					<div key={meetingId} className="meeting-group">
						<h2>
							<a href={`/participants/${meetingId}`}>
								Meeting ID: {meetingId}
							</a>
						</h2>
						<p>
							Participants Count:{' '}
							{groupedParticipants[meetingId].length}
						</p>
						{mid && (
							<>
								<RoulettePro
									key={`spin-${meetingId}`}
									start={start}
									spinningTime={10}
									prizes={indexedParticipants(
										groupedParticipants[meetingId]
									)}
									defaultDesignOptions={{
										prizesWithText: true
									}}
									option={{
										stopInCenter: true
									}}
									prizeIndex={randomIndex(
										indexedParticipants(
											groupedParticipants[meetingId]
										)
									)}
								/>

								<button className="btn" onClick={handleStart}>
									Spin
								</button>
							</>
						)}
						<table className="participants-table">
							<thead>
								<tr>
									<th>Email</th>
									<th>User ID</th>
									<th>User Name</th>
									<th>Join Time</th>
									<th>Minutes Since Last Join</th>
								</tr>
							</thead>
							<tbody>
								{groupedParticipants[meetingId].map(
									(participant) => (
										<tr key={participant.user_id}>
											<td>{participant.email}</td>
											<td>{participant.user_id}</td>
											<td>{participant.user_name}</td>
											<td>
												{new Date(
													participant.latest_join_time
												).toLocaleString()}
											</td>
											<td>
												{Math.floor(
													participant.minutes_since_last_join
												)}{' '}
												minutes
											</td>
										</tr>
									)
								)}
							</tbody>
						</table>
					</div>
				))
			)}
		</div>
	);
};

export default OnlineParticipants;
